import { h, render, Component } from 'preact';
import moment from 'moment';

import Form from './components/Form';
import Result from './components/Result';

class PbeakkCalculator extends Component {

	constructor(props) {
		super(props);

		this.init()
	}
	init() {

		let calculatorType = this.props.calculatorType;

		let birthDay = "01";
		let birthMonth="01";
		let birthYear=this.initialYear;
		let insuranceEntryDate = this.initialInsuranceEntryDate;

		this.state = {
			calculatorType: calculatorType,
			birthDay: birthDay,
			birthMonth: birthMonth,
			birthYear: birthYear,
			insuranceEntryDate: insuranceEntryDate,
			result: null
		}
	}

	handleBirthDayChange(event) {
		let birthDay = this.validateBirthDayDate(event.target.value);
		this.setState({
			birthDay: birthDay
		});
	}

	handleBirthMonthChange(event) {
		this.setState({
			birthMonth: event.target.value
		});
	}

	handleBirthYearChange(event) {
		this.setState({
			birthYear: event.target.value
		});
	}

	handleInsuranceEntryChange(event) {
		this.setState({
			insuranceEntryDate: event.target.value
		});
	}

	handleCalculate() {
		let result = null;
		const entryAge = this.calculateEntryAge();
		let errorMaxAge = false;

		if (this.props.maxRealAge != undefined) {
			errorMaxAge = this.validateEntryAgeWithRealMaxAge();
		} else {
			errorMaxAge = this.validateEntryAgeWithMaxAge(entryAge);
		}

		if (errorMaxAge == false) {
			result = this.dataByEntryAge(entryAge);
		}

		this.setState({
			entryAge: entryAge,
			result: result
		});
	}

	validateEntryAgeWithMaxAge(entryAge) {
		let errorMaxAge = false;
		let error = null;
		if (entryAge > parseInt(this.props.maxAge)) {
			errorMaxAge = true;
			error = {errorMaxAge: true};
		}
		this.setState({
			error: error,
		});

		return errorMaxAge;
	}

	validateEntryAgeWithRealMaxAge() {

		let birthDay = this.state.birthDay;
		let birthMonth = this.state.birthMonth;
		let birthYear = this.state.birthYear;
		let birthDayDate = birthDay + '.' + birthMonth + '.' + birthYear;
		let birthDayDateMoment = moment(birthDayDate, 'DD.MM.YYYY');
		let insuranceEntryDateYear = moment(this.state.insuranceEntryDate, 'DD.MM.YYYY');
		let realEntryAge = moment(insuranceEntryDateYear, 'DD.MM.YYYY').diff(birthDayDateMoment, 'years', true);
		let errorMaxAge = false;
		let maxAge = this.props.maxAge;
		let error = null;

		if (this.props.maxRealAge != null) {
			maxAge = this.props.maxRealAge;
		}

		if (realEntryAge >= maxAge) {
			errorMaxAge = true;
			error = {errorMaxAge: true};
		}
		this.setState({
			error: error,
		});

		return errorMaxAge;
	}

	validateBirthDayDate(birthDay){

		let birthMonth = this.state.birthMonth;
		let birthYear = this.state.birthYear;
		let birthDayDate = birthDay + '.' + birthMonth + '.' + birthYear;

		let isValid = moment(birthDayDate, 'DD.MM.YYYY').isValid();
		if (!isValid) {
			birthDay = birthDay - 1;
			this.validateBirthDayDate(birthDay);
		}
		return birthDay;
	}

	calculateEntryAge() {
		let birthYear = parseInt(this.state.birthYear);
		let insuranceEntryDateYear = parseInt(moment(this.state.insuranceEntryDate, 'DD.MM.YYYY').format('YYYY'));
		let entryAge = insuranceEntryDateYear - birthYear;

		return entryAge;
	}

	dataByEntryAge(entryAge) {
		entryAge = parseInt(entryAge);
		let data = this.props.data;
		let result = null;

		data.forEach( item => {
			if (item.entryAge == entryAge) {
				result = item;
			}
		});

		return result;
	}

	render() {

		let handleBirthDayChange = this.handleBirthDayChange.bind(this);
		let handleBirthMonthChange = this.handleBirthMonthChange.bind(this);
		let handleBirthYearChange = this.handleBirthYearChange.bind(this);
		let handleInsuranceEntryChange = this.handleInsuranceEntryChange.bind(this);
		let handleCalculate = this.handleCalculate.bind(this);

		return (
			<div>
				<Form
					calculatorType = {this.props.calculatorType}
					calculatorTypeUid = {this.props.calculatorTypeUid}
					minAge={this.props.minAge}
					maxAge={this.props.maxAge}
					birthDay={this.state.birthDay}
					birthMonth={this.state.birthMonth}
					birthYear={this.state.birthYear}
					insuranceEntryDate={this.state.insuranceEntryDate}
					insuranceEntryDates={this.insuranceEntryDates}
					handleBirthDayChange={handleBirthDayChange}
					handleBirthMonthChange={handleBirthMonthChange}
					handleBirthYearChange={handleBirthYearChange}
					handleInsuranceEntryChange={handleInsuranceEntryChange}
					handleCalculate={handleCalculate}

				/>
				<Result
					calculatorType = {this.props.calculatorType}
					calculatorTypeUid = {this.props.calculatorTypeUid}
					steps = {this.props.steps}
					entryAge={this.state.entryAge}
					maxAge={this.props.maxAge}
					result={this.state.result}
					error={this.state.error}
				/>
			</div>
		);
	}

	get initialYear() {
		return this.props.birthYear || moment().subtract(50,'years').format('YYYY');
	}

	get initialInsuranceEntryDate() {
		return this.props.birthYear || this.insuranceEntryDates[0]
	}

	get insuranceEntryDates() {
		let nextMonth = moment().startOf('month').add(1, 'month');

		let endOfYear = moment(nextMonth, 'DD.MM.YYYY').endOf("year");
		let endOfNextYear = moment(endOfYear, 'DD.MM.YYYY').add(1,'years');

		let months = moment(endOfNextYear).diff(nextMonth, 'month', true);
		months = Math.round(months) -1;

		let insuranceEntryDates = [];
		insuranceEntryDates.push(moment(nextMonth, 'DD.MM.YYYY').format('DD.MM.YYYY'));
		let insuranceEntryDate = nextMonth;

		for (var i = 0; i < months; i++) {
			insuranceEntryDate = moment(insuranceEntryDate, 'DD.MM.YYYY').startOf('month').add(1, 'month').format('DD.MM.YYYY');
			insuranceEntryDates.push(insuranceEntryDate);
		}

		return insuranceEntryDates;
	}
}

export default PbeakkCalculator;
